var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"suporte-page-content assinaturas"},[(_vm.loading)?_c('div',{staticClass:"flex items-center"},[_c('sl-loading',{staticClass:"size-18 m-r-sm",attrs:{"content":""}}),_vm._v(" Buscando assinaturas ativas...")],1):_vm._e(),_c('cliente-contratos',{on:{"load":_vm.load}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }